import { render, staticRenderFns } from "./repassesmedicos.vue?vue&type=template&id=5074bd5e&"
import script from "./repassesmedicos.vue?vue&type=script&lang=js&"
export * from "./repassesmedicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports